export default {
  name: 'CoreButton',
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: ''
    },
    prependIcon: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: ''
    },
    solidIcon: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    text: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    hasEmptySlot: false,
    commonAttrs: {}
  }),
  computed: {
    iconPrefix() {
      return this.solidIcon ? 'fas' : 'fal';
    },
    hasToolTip() {
      return this.tooltip && String(this.tooltip).length;
    },
    classButtonRounded() {
      return this.active ? `bg-rounded-button-solid-${this.color} white--text` : `bg-rounded-button-${this.color}`;
    },
    classCursorPointer() {
      return this.$attrs.href || this.$attrs.to || this.$listeners.click ? 'cursor-pointer' : '';
    }
  },
  created() {
    this.hasEmptySlot = Boolean(!this.$slots.default);
  },
  beforeUpdate() {
    this.hasEmptySlot = Boolean(!this.$slots.default);
  }
};